import { NgModule } from '@angular/core'
import { CourtSystemService } from './court-system.service'

@NgModule({
  providers: [CourtSystemService],
})
export class CourtSystemServiceModule {}
